import QRCode from 'qrcode';

export default {
    generateQRCodeForCanvas : function (canvas, alert) {
        if (!canvas || !canvas.dataset) {
            alert.textContent = $t('Klarte ikke generere QR-kode. Prøv igjen senere.');
            alert.classList.remove('hide');
            return;
        }
        QRCode.toCanvas(canvas, canvas.dataset.content, {width: 180, height: 180, margin: 0}, function (e) {
            if (e) {
                console.error(e);
                alert.textContent = $t('Klarte ikke generere QR-kode. Prøv igjen senere.');
                alert.classList.remove('hide');
            }
        })
        canvas.removeAttribute('data-content');
    }
}

